import { Box } from '@mui/material';

export const SideNavbarFooter: React.FC = () => {
  return (
    <Box
      sx={{
        borderTop: '1px solid rgba(255, 255, 255, 0.16)',
        mt: 'auto',
      }}
    />
  );
};
